import { ModalHandler } from '@app-velocity/ui';

import { PaidTeamAvailableModalContent } from './components/PaidTeamAvailableModalContent';

export const PaidTeamAvailableModal = () => {
  return (
    <ModalHandler id="paid-team-available" channel="teams">
      <PaidTeamAvailableModalContent />
    </ModalHandler>
  );
};
